/*
 * Shared "does this panel currently show findings under review?" selectors.
 * Used by the panels (to auto-collapse their controls section) and by App.tsx
 * (to hide the dependency info bar), so the two can never drift apart.
 */

import type { AppData } from "./store";
import type { TabId } from "./types";

export const hasLiveFindings = (s: AppData): boolean =>
  (s.currentLiveSuggestionIndex >= 0 && s.currentLiveSuggestionIndex < s.liveSuggestions.length) ||
  (s.liveRepetitionEnabled && s.liveRepetitions.length > 0);

export const hasSelectionFindings = (s: AppData): boolean =>
  s.currentOccurrenceIndex >= 0 && s.currentOccurrenceIndex < s.occurrences.length;

export const hasSuggestionFindings = (s: AppData): boolean =>
  (s.currentDocSuggestionIndex >= 0 && s.currentDocSuggestionIndex < s.docSuggestions.length) ||
  (s.currentReviewSelectionIndex >= 0 &&
    s.currentReviewSelectionIndex < s.reviewSelectionSuggestions.length);

export function hasTabFindings(s: AppData, tab: TabId): boolean {
  switch (tab) {
    case "live":
      return hasLiveFindings(s);
    case "suggestions":
      return hasSuggestionFindings(s);
    case "selection":
      return hasSelectionFindings(s);
    default:
      return false;
  }
}
